import React from "react";
import {useTranslation} from "react-i18next";
import {DEFAULT_BRAND} from "@/enums/brands";
import BrandImage from "../../common/BrandImage";

const AgentHeader: React.FC<{brandOverride?: string; agentName?: string}> = ({
   brandOverride,
   agentName,
}) => {
   const {t} = useTranslation("ask");
   return (
      <div className="flex items-center mb-3">
         <BrandImage brand={brandOverride ?? DEFAULT_BRAND} className="inline" height={16} variant="small" />
         <span className="font-medium ml-2 text-sm text-foreground">
            <span className="mr-1">&bull;</span>
            {agentName ? ` ${agentName}` : ` ${t("agent")}`}
         </span>
      </div>
   );
};

export default AgentHeader;
